import { FC } from 'react';
import { classes } from './Navigation.st.css';
import { AccountButton } from '../AccountButton';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import { selectSite } from 'src/features/site-slice';
import { EVENTS_ROOT } from 'src/redesign/shared/routes';

export const Navigation: FC = () => {
  const currentSite = useAppSelector(selectSite);
  return (
    <nav className={classes.navigation}>
      <a href="https://www.ticketspotapp.com/faq" className={classes.navigationLink}>
        FAQ
      </a>
      <a href="https://ticketspotapp.com/docs" className={classes.navigationLink}>
        Learning Spot
      </a>
      <Link to={`${EVENTS_ROOT}/${currentSite?.id}/billing`} className={classes.navigationLink}>
        Billing
      </Link>
      <AccountButton />
    </nav>
  );
};
